var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6728 10.7237C21.6728 4.8961 16.9773 0.171875 11.185 0.171875C5.3928 0.171875 0.697266 4.8961 0.697266 10.7237C0.697266 15.9904 4.53247 20.3558 9.54633 21.1474V13.7739H6.88341V10.7237H9.54633V8.39904C9.54633 5.75447 11.1121 4.2937 13.5077 4.2937C14.6548 4.2937 15.8554 4.49979 15.8554 4.49979V7.09654H14.5329C13.2302 7.09654 12.8238 7.90998 12.8238 8.74527V10.7237H15.7325L15.2675 13.7739H12.8238V21.1474C17.8376 20.3558 21.6728 15.9904 21.6728 10.7237Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4e4275aa6e3d47777046c192f157f8d7.svg";
export { ForwardRef as ReactComponent };